import { render, staticRenderFns } from "./CustomerLevel.vue?vue&type=template&id=c3c68dd0&scoped=true"
import script from "./CustomerLevel.vue?vue&type=script&lang=js"
export * from "./CustomerLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c68dd0",
  null
  
)

export default component.exports